import React from "react";
import theme from "../../theme.scss";
import { IconProps } from "./types";

export const InstallPerformanceIcon = ({ width, colour }: IconProps) => {
  return (
    <svg width={width || 30} viewBox="0 0 24 24" id="InstallPerformanceIcon">
      <path
        d="M3 3V21H21"
        stroke={colour || theme.white}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <rect x="6" y="13" width="3" height="6" rx="0.5" fill={colour || theme.white} />
      <rect x="11" y="8" width="3" height="11" rx="0.5" fill={colour || theme.white} />
      <rect x="16" y="4" width="3" height="15" rx="0.5" fill={colour || theme.white} />
    </svg>
  );
};
